import { BreadCrumbs as BreadCrumbsComponent } from '../../components/BreadCrumbs';
import { useSelector } from 'react-redux';
import { breadcrumpsSelector } from '../../selectors/newbuilding';
import { Responsive } from '@cian/ui-kit';

export const BreadCrumbs = () => {
  const breadCrumbs = useSelector(breadcrumpsSelector);

  if (breadCrumbs.length === 0) {
    return null;
  }

  return (
    <Responsive desktop>
      <BreadCrumbsComponent breadCrumbs={breadCrumbs} />
    </Responsive>
  );
};
